import { isTablet, _t } from '../base'

export function newsletter() {
    const newsletter = $('.custom-footer__newsletter')

    newsletter.addClass('container').insertBefore('#footer')
    newsletter.find('.topic span').text(_t('newsletter.title'))
    newsletter.find('input').attr('placeholder', _t('input.emailPlaceholder'))
    newsletter.contents().wrapAll($('<div class="newsletter-wrapper"></div>'))
    newsletter.find('.btn').text(_t('newsletter.btn'))

    if (isTablet()) return

    newsletter.find('.btn').insertAfter(newsletter.find('input.form-control'))
}
